import axios from "axios";

export const getBookingSippList =  async (req: { tenants: string[], dealers: string[] }): Promise<string[]> => {
    const response = await axios.get('/booking/search/sipps', { params:{
        tenants: req.tenants.join(","),
        dealers: req.dealers.join(",")
    } });
    return response.data;
};
